export default {
  install(Vue, options) {
    Vue.getCurrentDate = function() {
      const date = new Date();
      return date;
    };

    Vue.$user = {
      name: "哈哈",
      age: 19
    };
    Vue.ajaxGet = function(_self, url, params, loading) {
      return new Promise((resolve, reject) => {
        _self[loading] = true;
        _self
          .$http({
            url: url,
            method: "GET",
            params: params
          })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              const result = res.body.data;
              if (result) {
                _self[loading] = false;
                resolve(result);
              }
            } else {
              _self[loading] = false;
            }
          })
          .catch(err => {
            _self[loading] = false;
            console.error(err);
          });
      });
    };
    Vue.ajaxDel = function(_self, url, params) {
      return new Promise((resolve, reject) => {
        _self
          .$http({
            url: url,
            method: "DELETE",
            params: params
          })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              const result = res.body;
              if (result) {
                resolve(result);
              }
            } else {
            }
          })
          .catch(err => {
            console.error(err);
          });
      });
    };
    Vue.ajaxPost = function(
      _self,
      url,
      body,
      emulateHTTP = false,
      emulateJSON = false,
      header
    ) {
      Vue.http.options.emulateHTTP = emulateHTTP;
      Vue.http.options.emulateJSON = emulateJSON;
      return new Promise((resolve, reject) => {
        _self
          .$http({
            url: url,
            method: "POST",
            body: body,
            headers: header
          })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              const result = res.body;
              if (result) {
                resolve(result);
                Vue.http.options.emulateHTTP = false;
                Vue.http.options.emulateJSON = false;
              }
            } else {
            }
          })
          .catch(err => {
            console.error(err);
          });
      });
    };

    Vue.ajaxPut = function(
      _self,
      url,
      body,
      loading,
      emulateHTTP = false,
      emulateJSON = false
    ) {
      Vue.http.options.emulateHTTP = emulateHTTP;
      Vue.http.options.emulateJSON = emulateJSON;
      _self[loading] = true;
      return new Promise((resolve, reject) => {
        _self
          .$http({
            url: url,
            method: "PUT",
            body: body
          })
          .then(res => {
            _self[loading] = false;
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              resolve(res.body);
              Vue.http.options.emulateHTTP = false;
              Vue.http.options.emulateJSON = false;
            } else {
            }
          })
          .catch(err => {
            _self[loading] = false;
            reject(err);
            console.error(err);
          });
      });
    };
  }
};
